<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-25 11:50:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-10 10:14:05
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/search.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="search">
		<div class="form-search">
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">商品名称</div>
				<div class="content">
					<el-input style="width: 240px" v-model="search.outerProductName" placeholder="请输入"></el-input>
				</div>
			</div>
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">商品ID</div>
				<div class="content">
					<el-input style="width: 240px" v-model="search.outerProductId" placeholder="请输入"></el-input>
				</div>
			</div>
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">店铺名称</div>
				<div class="content">
					<el-input style="width: 240px" v-model="search.outerShopName" placeholder="请输入"></el-input>
				</div>
			</div>
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">店铺ID</div>
				<div class="content">
					<el-input style="width: 240px" v-model="search.outerShopId" placeholder="请输入"></el-input>
				</div>
			</div>
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">来源机构名称</div>
				<div class="content">
					<el-input style="width: 240px" v-model="search.authorityName" placeholder="请输入"></el-input>
				</div>
			</div>
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">来源机构ID</div>
				<div class="content">
					<el-input style="width: 240px" v-model="search.originAuthorityId" placeholder="请输入"></el-input>
				</div>
			</div>
			<div class="form-item mb-16 mr-16">
				<div class="label fz-14">状态</div>
				<div class="content">
					<el-select clearable v-model="search.auditStatus" style="width: 240px;">
						<el-option v-for="item in AUDIT_STATUS_OPTIONS" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</div>
			</div>
            <div class="form-item-submit">
                <div class="label"></div>
                <div class="content">
                    <el-button type="primary" @click="onSearch()">搜索</el-button>
                    <el-button @click="onClear()">清空</el-button>
                </div>
            </div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			search: {
				outerProductName: '', //商品名称
				outerProductId: '', //商品id
				outerShopName: '', //店铺名称
				outerShopId: '', //店铺id
				authorityName: '', //来源机构名称
				originAuthorityId: '', //来源机构ID
				auditStatus: '', // 审核状态
			},
			AUDIT_STATUS_OPTIONS: newDataMap.SHOP_MANAGE.AUDIT_STATUS_OPTIONS,
		};
	},
    methods:{
        /**
         * 清空
         */
        onClear(){
            this.search = {
                outerProductName: '',
				productId: '',
				outerShopName: '',
				outerShopId: '',
				authorityName: '',
				originAuthorityId: '',
				auditStatus: '',
            }
            this.$emit('search',this.search)
        },
        /**
         * 搜索
         */
         onSearch(){
            this.$emit('search',this.search)
         }
    },
	created(){
		this.$emit('search',this.search)
	}
};
</script>
<style lang="less" scoped>
.form-search {
	display: flex;
	flex-wrap: wrap;
	.form-item {
		display: flex;
		align-items: center;
		.label {
			text-align: right;
			margin-right: 12px;
			min-width: 84px;
			font-family: 'PingFangSC-Regular';
			color: @color-gy8;
		}
        .content{
            flex: 1;
        }
	}
    .form-item-submit{
        display: flex;
		.label {
			text-align: right;
			margin-right: 12px;
			min-width: 84px;
			font-family: 'PingFangSC-Regular';
			color: @color-gy8;
		}
    }
}
</style>
